module.exports = __webpack_public_path__ + "assets/hamburger-21551c.svg";